<template>
<transition name='bbs_fade'>
  <div class="item" @click='detail'>
    <div class="user">
      <img :src="info.userIcon" class="avatar">
      <div class="msg">
        <p class="info">
          <span class="name">{{info.userName}}</span>
          <span class="position">{{info.position}}</span>
        </p>
        <p class="date">{{info.createTime | DateFilter('yyyy-MM-dd hh:mm')}}</p>
      </div>
      <div class="delete" v-show='user.userId === info.userId' @click.stop='isDelete'>
        <i class="iconfont icon-shanchu"></i>
      </div>
    </div>
    <!-- <p class="title">{{info.subject}}</p> -->
    <p class="thumb">
      <img v-if='info.thumb' :src="info.thumb">
    </p>
    <p class="description">{{info.content}}</p>

    <div class="opration">
      <div class="likes">
        <i class="iconfont icon-dianzan" @click.stop='like' :class='{ "active": amILike }'></i>
        <span class="likenums" @click.stop='like'>{{info.likes}}</span>
      </div>
      <div class="comments">
        <i class="iconfont icon-pinglun" @click.stop='comment'></i>
        <span class="commentsnums" @click.stop='comment'>{{info.comments}}</span>
      </div>
    </div>
  </div>
</transition>
  
</template>

<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
import { Dialog } from 'vant';

export default {
  data() {
    return {
      amILike: false,
      duration: 1500,
      orderId:'',
    };
  },
  props: {
    info: {
      type: Object,
      default() {
        return {};
      },
    },
    user: {
      type: Object,
    },
    newtoken:String,
  },
  methods: {
    // 点赞
    like() {
      this.$http.post(`${this.URL_PREFIX}/app/opt/bbs/likes/log`, { 
        postId: this.info.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.amILike = !this.amILike;
          if (this.amILike) {
            this.info.likes += 1;
          } else {
            this.info.likes -= 1;
          }
        }
      });
    },
    isDelete() {
      Dialog.confirm({
        title: '警告',
        message: '是否删除？'
      }).then(() => {
        this.deleteItem();
      }).catch(() => {
      });
    },
    // 删除
    deleteItem() {
      this.$http.post(`${this.URL_PREFIX}/app/delete/bbs/post`, {
        id: this.info.id,
      }, {
        headers: { token: localStorage.getItem('swtoken') },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.$emit('deleteBlog', this.info.id)
        } else {
          Toast.fail({ duration: this.duration, message:  res.resDesc});
        }
      });
    },
    // 详情
    detail() {
      // window.location.href = `${this.URL_PREFIX_PAGE}/bbs/detail/${this.info.id}`;
      this.$router.push({ path: `/bbs/detail/${this.info.id}`,query: { orderId: this.info.orderId } });
    },
    // 评论
    comment() {
      this.$router.push({ path: `/bbs/publishComment/${this.info.id}`,query: { orderId: this.info.orderId } });
    },
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    this.amILike = this.info.isLikes ? true : false;
  },
};
</script>


<style lang="scss" scoped>
@import '~@scss';

.item{
  padding: .32rem;
  background: #fff;
  margin-bottom: .266667rem;
  .user{
    display: flex;
    height: .8rem;
    line-height: .8rem;
    .avatar{
      flex: 0 0 .8rem;
      margin-right: .32rem;
      width: .8rem;
      height: .8rem;
      border-radius: 50%;
      border: none;
      vertical-align: top;
    }
    .msg{
      flex: 1 1 auto;
      color: rgb(102, 102, 102);
      .info{
        line-height: .426667rem;
        .name, .position{
          display: inline-block;
          vertical-align: bottom;
        }
        .name{
          font-size: .32rem;
        }
        .position{
          margin-left: .16rem;
          font-size: .24rem;
        }
      }
      .date{
        line-height: .373333rem;
        font-size: .24rem;
      }
    }
    .delete{
      flex: 0 0 .8rem;
      width: .8rem;
      text-align: center;
      .iconfont{
        font-size: .4rem;
        color: rgb(153, 153, 153);
      }
    }
  }
  .title{
    @include lines-ellipsis;
    margin: .266667rem 0;
    line-height: .64rem;
    font-size: .426667rem;
    font-weight: 600;
  }
  .thumb{
    margin-bottom: .266667rem;
    img{
      width: 100%;
      height: 4.906667rem;
      object-fit: contain;
    }
  }
  .description{
    @include lines-ellipsis;
    width: 100%;
    word-break: break-all;
    margin-bottom: .266667rem;
    line-height: .533333rem;
    max-height: 1.066667rem;
    font-size: .4rem;
    font-weight: 500;
  }

  .opration{
    display: flex;
    height: .666667rem;
    line-height: .666667rem;
    .likes, .comments{
      flex: 0 0 3.6rem;
      width: 3.6rem;
      .active{
        color: $color-main;
      }
    }
    i, span{
      padding: .16rem;
      box-sizing: border-box;
      font-size: .373333rem;
      color: rgb(102, 102, 102);
    }
  }
}

.bbs_fade-enter-active, .bbs_fade-leave-active {
  transition: opacity .5s;
}
.bbs_fade-enter, .bbs_fade-leave-to{
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/bbs/components/child/BlogItem.vue